<template>
  <b-row>
    <b-col cols="12" v-if="weekDays && weekDays && weekDays.length > 0">
      <slot></slot>
      <b-row cols="6" no-gutters>
        <b-col
          style="padding: 2px"
          cols="4"
          md="2"
          lg="2"
          xl="1"
          v-for="(day, index) in weekDays"
          :key="index"
        >
          <b-button
            @click="setSelectedWeekDay(day)"
            class="w-100 small-font-size"
            style="min-width: max-content"
            :variant="day == selectedWeekDay ? 'success' : ''"
          >
            {{ getWeekDay(day) }}
          </b-button>
        </b-col>
      </b-row>
    </b-col>
    <b-col class="mt-3" cols="12" md="8" v-if="selectedWeekDay">
      <h3>
        افزودن بازه برای روز
        {{
          new Date(selectedWeekDay).toLocaleDateString("fa-IR", {
            weekday: "long",
          })
        }}
        تاریخ
        {{ new Date(selectedWeekDay).toLocaleDateString("fa-IR") }}
      </h3>
      <hr />
      <b-button
        variant="transparent"
        @click="addNewTimePeriod"
        class="cursor-pointer d-flex align-items-center"
      >
        <span class="mr-1">افزودن بازه‌ی جدید</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="text-success"
          style="width: 1.5rem; height: 1.5rem"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </b-button>
      <template v-if="userTimePeriods && userTimePeriods.length > 0">
        <div
          class="d-flex flex-column flex-md-row align-items-center mt-1"
          v-for="(period, index) in userTimePeriods"
          :key="index"
        >
          <div
            class="d-flex align-items-center mr-md-1 mb-1 mb-md-0"
            style="column-gap: 1rem"
          >
            <p class="mb-0">از:</p>
            <b-input-group class="input-group-merge">
              <b-form-input
                :id="`startTime${index}-${weekUniqueText}`"
                :class="`startTime${index}-${weekUniqueText}`"
                placeholder="بازه‌ی تاریخ را انتخاب کنید"
              ></b-form-input>
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  icon="ClockIcon"
                  size="18"
                />
                <date-picker
                  :customInput="`.startTime${index}-${weekUniqueText}`"
                  :jumpMinute="10"
                  :roundMinute="true"
                  v-model="period.startTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="HH:mm"
                  type="time"
                ></date-picker>
              </b-input-group-append>
            </b-input-group>
          </div>
          <div class="d-flex align-items-center" style="column-gap: 1rem">
            <p class="mb-0">تا:</p>
            <b-input-group class="input-group-merge">
              <b-form-input
                :id="`endTime${index}-${weekUniqueText}`"
                :class="`endTime${index}-${weekUniqueText}`"
                placeholder="بازه‌ی تاریخ را انتخاب کنید"
              ></b-form-input>
              <b-input-group-append is-text>
                <feather-icon
                  class="cursor-pointer"
                  icon="ClockIcon"
                  size="18"
                />
                <date-picker
                  :customInput="`.endTime${index}-${weekUniqueText}`"
                  :jumpMinute="10"
                  :roundMinute="true"
                  v-model="period.endTime"
                  format="YYYY-MM-DD HH:mm:ss"
                  display-format="HH:mm"
                  type="time"
                ></date-picker>
              </b-input-group-append>
            </b-input-group>
          </div>
          <b-button variant="transparent" @click="removePeriod(period)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="text-danger"
              style="width: 1.5rem; height: 1.5rem"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
              />
            </svg>
          </b-button>
        </div>
      </template>
      <template v-else>
        <p class="mt-2 ml-2">جهت افزودن بازه‌ی زمانی روی دکمه + کلیک کنید</p>
      </template>
    </b-col>
    <b-col cols="12" md="4" class="mt-3" v-if="selectedWeekDay">
      <h3>
        بازه های ثبت شده برای تاریخ
        {{ new Date(selectedWeekDay).toLocaleDateString("fa-IR") }}
      </h3>
      <hr />
      <template
        v-if="masterPreviousSchedules && masterPreviousSchedules.length > 0"
      >
        <master-time-period-card
          v-for="(schedule, index) in masterPreviousSchedules"
          :key="index"
          :scheduleDetails="schedule"
          @getDeleteConfirmationForSchedule="getDeleteConfirmationForSchedule"
          @updateMasterPeriods="updateMasterPeriods"
          @loading="startLoading"
          @loaded="endLoading"
          :availableWeekDays="weekDaysToSetDatesIn"
        ></master-time-period-card>
      </template>
      <template v-else>
        <p class="text-center small-font-size">
          در این تاریخ هیچ بازه‌ی زمانی فعالی ندارید!
        </p>
      </template>
    </b-col>
    <b-col cols="12">
      <hr />
      <h4>ثبت برای روز های دیگر:</h4>
      <b-row>
        <template
          v-if="weekDaysToSetDatesIn && weekDaysToSetDatesIn.length > 0"
        >
          <b-col
            style="padding: 2px"
            cols="4"
            md="2"
            lg="2"
            xl="1"
            v-for="(date, index) in weekDaysToSetDatesIn"
            :key="index"
          >
            <b-form-checkbox
              :checked="isDateExistInRepeat(date)"
              name="check-button"
              switch
              @change="setWeekDayForRepeatSchedule($event, date)"
            >
              {{ getWeekDay(date) }}
            </b-form-checkbox>
          </b-col>
        </template>
        <template v-else>
          <b-col cols="12">زمان دیگری جهت انتخاب وجود ندارد!</b-col>
        </template>
      </b-row>
      <b-row>
        <b-col cols="12" class="mt-4">
          <div class="w-100 d-flex justify-content-end">
            <b-button
              :disabled="isSubmitButtonDisabled"
              variant="success"
              @click="sendMasterScheduleCreateRequest"
            >
              ثبت
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-col>
    <!-- Delete Confirmation Modal Start -->
    <b-modal
      title="حذف زمانبندی"
      :id="`modal-schedule-delete-${weekUniqueText}`"
      centered
      ok-title="حذف"
      cancel-title="بستن"
      ok-variant="danger"
      @ok="deleteAMasterSchedule"
    >
      <b-container fluid>
        <b-form-row>
          <b-col cols="12" v-if="tempSchedule">
            <p>
              آیا از حذف زمانبندی برای تاریخ

              {{
                new Date(this.tempSchedule.startTime).toLocaleDateString(
                  "fa-IR"
                )
              }}

              از ساعت

              {{
                new Date(this.tempSchedule.startTime).toLocaleTimeString(
                  "fa-IR",
                  {
                    hour: "2-digit",
                    minute: "2-digit",
                  }
                )
              }}

              تا ساعت

              {{
                new Date(this.tempSchedule.endTime).toLocaleTimeString(
                  "fa-IR",
                  {
                    hour: "2-digit",
                    minute: "2-digit",
                  }
                )
              }}
              اطمینان دارید؟
            </p>
          </b-col>
        </b-form-row>
      </b-container>
    </b-modal>
    <!-- Delete Confirmation Modal End -->
  </b-row>
</template>
<script>
export default {
  emits: ["loading", "loaded"],
  props: {
    weekDays: {
      type: Array,
      required: false,
    },
    weekUniqueText: {
      type: String,
      required: true,
    },
    isForNextWeek: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedWeekDay: null,
      masterSchedulePayload: {
        count: 100,
        pageNumber: 1,
        masterUserId: getUserData().user.userId,
        targetDate: null,
        effectJustReserve: false,
      },
      userTimePeriods: [
        {
          startTime: null,
          endTime: null,
        },
      ],
      convertedTimePeriosForApiPayload: [],
      masterPreviousSchedules: null,
      tempSchedule: null,
      weekDaysToSetDatesIn: [],
      weekDayForRepeatSchedule: [],
    };
  },
  methods: {
    setWeekDayForRepeatSchedule(isChecked, date) {
      if (isChecked) {
        this.setDateToWeekDayForRepeat(date);
      } else {
        this.removeDateToWeekDayForRepeat(date);
      }
    },
    setDateToWeekDayForRepeat(date) {
      this.weekDayForRepeatSchedule.push(date);
    },
    removeDateToWeekDayForRepeat(date) {
      this.weekDayForRepeatSchedule = this.weekDayForRepeatSchedule.filter(
        (time) => time != date
      );
    },
    loading() {
      this.$emit("loading");
    },
    loaded() {
      this.$emit("loaded");
    },
    async getValidDatesForMasterToSetScheduleIn() {
      try {
        this.weekDays = [];
        this.loading();
        let _this = this;
        let validDatesForMaster = new ValidDatesForMaster(_this);
        await validDatesForMaster.fetch((res) => {
          this.weekDays = res;
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loaded();
      }
    },
    async deleteAMasterSchedule() {
      try {
        this.loading();
        let _this = this;
        let deleteMasterScheduleByList = new DeleteMasterScheduleByList(_this);
        deleteMasterScheduleByList.setRequestParamDataObj([
          _this.tempSchedule.masterScheduleId,
        ]);
        await deleteMasterScheduleByList.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "زمانبندی با موفقیت حذف شد",
                icon: "Trash2Icon",
                variant: "success",
              },
            });
            _this.getMasterSchedulesForDate();
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "مشکلی پیش آمد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "لطفا دوباره تلاش کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loaded();
      }
    },
    async sendMasterScheduleCreateRequest() {
      const daysToLoopForRequest = [this.selectedWeekDay];
      this.weekDayForRepeatSchedule.forEach((item) =>
        daysToLoopForRequest.push(item)
      );
      daysToLoopForRequest.forEach(async (item) => {
        try {
          this.createSchedulePayload(item);
          this.loading();
          let _this = this;
          let createMasterScheduleByList = new CreateMasterScheduleByList(
            _this
          );
          createMasterScheduleByList.setRequestParamDataObj({
            masterUserId: getUserData().user.userId,
            periods: _this.convertedTimePeriosForApiPayload,
            isForNextWeek: _this.isForNextWeek,
          });
          await createMasterScheduleByList.fetch(
            function (res) {
              if (res.isSuccess) {
                _this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "زمانبندی با موفقیت انجام شد",
                    icon: "UserCheckIcon",
                    variant: "success",
                  },
                });
                _this.userTimePeriods = [
                  {
                    startTime: null,
                    endTime: null,
                  },
                ];
                _this.getMasterSchedulesForDate();
              } else {
                _this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "مشکلی پیش آمد!",
                    icon: "XIcon",
                    variant: "danger",
                    text: res.errors || "لطفا دوباره تلاش کنید",
                  },
                });
              }
            },
            function (error) {
              console.error(error);
            }
          );
        } catch (error) {
          console.error(error);
        } finally {
          this.loaded();
        }
      });
    },
    getDeleteConfirmationForSchedule(schedule) {
      this.tempSchedule = JSON.parse(JSON.stringify(schedule));
      this.$bvModal.show(`modal-schedule-delete-${this.weekUniqueText}`);
    },
    createSchedulePayload(date) {
      // Convert Date object to utc
      // And add it to new array to send to api
      this.convertedTimePeriosForApiPayload = [];
      this.userTimePeriods.forEach((item) => {
        let customEndTime = item.endTime;

        // Set time to 23:59:59 if user selected 00:00 to prevent from changing dates
        if (
          new Date(customEndTime).getHours() == 0 &&
          new Date(customEndTime).getMinutes() == 0
        ) {
          customEndTime = new Date(customEndTime).setHours(23, 59, 59);
        }
        if (item.startTime && item.endTime) {
          this.convertedTimePeriosForApiPayload.push({
            startTime: new Date(
              new Date(item.startTime).setFullYear(
                new Date(date).getFullYear(),
                new Date(date).getMonth(),
                new Date(date).getDate()
              )
            ),
            endTime: new Date(
              new Date(customEndTime).setFullYear(
                new Date(date).getFullYear(),
                new Date(date).getMonth(),
                new Date(date).getDate()
              )
            ),
          });
        }
      });
    },
    removePeriod(period) {
      this.userTimePeriods = this.userTimePeriods.filter(
        (item) => item != period
      );
    },
    addNewTimePeriod() {
      this.userTimePeriods.push({
        startTime: null,
        endTime: null,
      });
    },
    setSelectedWeekDay(day) {
      this.removeDateToWeekDayForRepeat(day);
      this.selectedWeekDay = day;
      this.weekDaysToSetDatesIn = this.weekDays.filter(
        (dateTime) => dateTime != day
      );
      this.getMasterSchedulesForDate();
    },
    getWeekDay(dateObject) {
      if (dateObject) {
        return new Date(dateObject).toLocaleDateString("fa-IR", {
          weekday: "long",
        });
      }
    },
    updateMasterPeriods() {
      this.getMasterSchedulesForDate();
    },
    startLoading() {
      this.loading();
    },
    endLoading() {
      this.loaded();
    },
    isDateExistInRepeat(date) {
      if (
        this.weekDayForRepeatSchedule &&
        this.weekDayForRepeatSchedule.length > 0
      ) {
        if (this.weekDayForRepeatSchedule.includes(date)) {
          return true;
        }
        return false;
      }
    },
    async getMasterSchedulesForDate() {
      this.masterSchedulePayload.targetDate = this.selectedWeekDay;
      this.masterSchedulePayload["isForNextWeek"] = this.isForNextWeek;
      try {
        this.loading();
        let _this = this;
        let getAllMasterSchedule = new GetAllMasterSchedule(_this);
        getAllMasterSchedule.setRequestParamDataObj(
          _this.masterSchedulePayload
        );
        await getAllMasterSchedule.fetch((res) => {
          if (res.isSuccess) {
            _this.masterPreviousSchedules = res.data.masterSchedules;
          } else {
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.loaded();
      }
    },
  },
  computed: {
    isSubmitButtonDisabled() {
      if (this.userTimePeriods && this.userTimePeriods.length > 0) {
        return this.userTimePeriods.some(
          (item) => !item.startTime || !item.endTime
        );
      } else {
        return true;
      }
    },
  },
  components: {
    BRow,
    BCol,
    BFormRow,
    BFormInput,
    BButton,
    BModal,
    BContainer,
    BInputGroup,
    BInputGroupAppend,
    MasterTimePeriodCard,
    BFormCheckbox,
  },
};
import {
  CreateMasterScheduleByList,
  DeleteMasterScheduleByList,
  GetAllMasterSchedule,
  ValidDatesForMaster,
} from "@/libs/Api/MasterSchedule";
import { getUserData } from "@/auth/utils";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import MasterTimePeriodCard from "./MasterTimePeriodCard.vue";
import {
  BRow,
  BCol,
  BFormRow,
  BFormInput,
  BButton,
  BModal,
  BContainer,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
} from "bootstrap-vue";
</script>
